/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {DebugContext} from './view/index';

export const /** @type {?} */ ERROR_TYPE = 'ngType';
export const /** @type {?} */ ERROR_COMPONENT_TYPE = 'ngComponentType';
export const /** @type {?} */ ERROR_DEBUG_CONTEXT = 'ngDebugContext';
export const /** @type {?} */ ERROR_ORIGINAL_ERROR = 'ngOriginalError';
export const /** @type {?} */ ERROR_LOGGER = 'ngErrorLogger';
/**
 * @param {?} error
 * @return {?}
 */
export function getType(error: Error): Function {
  return ( /** @type {?} */((error as any)))[ERROR_TYPE];
}
/**
 * @param {?} error
 * @return {?}
 */
export function getDebugContext(error: Error): DebugContext {
  return ( /** @type {?} */((error as any)))[ERROR_DEBUG_CONTEXT];
}
/**
 * @param {?} error
 * @return {?}
 */
export function getOriginalError(error: Error): Error {
  return ( /** @type {?} */((error as any)))[ERROR_ORIGINAL_ERROR];
}
/**
 * @param {?} error
 * @return {?}
 */
export function getErrorLogger(error: Error): (console: Console, ...values: any[]) => void {
  return ( /** @type {?} */((error as any)))[ERROR_LOGGER] || defaultErrorLogger;
}
/**
 * @param {?} console
 * @param {...?} values
 * @return {?}
 */
function defaultErrorLogger(console: Console, ...values: any[]) {
  ( /** @type {?} */((<any>console.error)))(...values);
}


// WEBPACK FOOTER //
// ../../../../packages/core/src/errors.ts